import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {BicButtonComponent, BicInputComponent, BicPopupComponent} from '@buildinginformationcloud/bic-ui-components';

/** Namensabfrage vor dem Anlegen eines Prüflaufs – aus der Prüflauf-Liste und aus einem myCheck. */
@Component({
  selector: 'app-create-check-run-prompt',
  standalone: true,
  imports: [BicPopupComponent, BicButtonComponent, BicInputComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <bic-popup (close)="onClose()" [customClass]="'w-[698px]'" [title]="'Prüflauf erstellen'">
      <div bicPopupContent class="flex flex-col gap-6">
        <bic-input (keyup.enter)="onConfirm()"
                   (valueChange)="name = $event"
                   [label]="'Name'"
                   [placeholder]="'z.B. Brandschutz Check'"
                   [value]="name">
        </bic-input>
        @if (hint) {
          <p class="text-xs text-gray-500">{{ hint }}</p>
        }
      </div>
      <div bicPopupButtonGroup class="flex w-full flex-row items-center justify-end gap-4">
        <bic-button (onClick)="onClose()" [disabled]="saving" buttonType="white">Abbrechen</bic-button>
        <bic-button (onClick)="onConfirm()" [disabled]="!name.trim()" [loading]="saving">Erstellen</bic-button>
      </div>
    </bic-popup>
  `,
})
export class CreateCheckRunPromptComponent implements OnInit {
  @Input() initialName = '';
  @Input() hint = '';
  @Input() saving = false;

  @Output() closed = new EventEmitter<void>();
  @Output() confirmed = new EventEmitter<string>();

  protected name = '';

  ngOnInit(): void {
    this.name = this.initialName;
  }

  protected onClose(): void {
    if (this.saving) return;
    this.closed.emit();
  }

  protected onConfirm(): void {
    const name = this.name.trim();
    if (!name || this.saving) return;
    this.confirmed.emit(name);
  }
}
